import { Button, Stack, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import '../../global.css';
import FormField from "../form/formField";
import { useSnackbar } from "notistack";
import authServices from "../../services/authServices";
import logsService from "../../services/logServices";
import { InvestorActivityEventType } from "../../utils/eventTypes";

const OTPForm = ({ otp, setOtp, number, setOtpForm, handleVerifyOtp, submitting = false }) => {

    const { enqueueSnackbar } = useSnackbar();
    const [timer, setTimer] = useState(15);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        let interval;

        if (disabled && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setDisabled(false);
        }

        return () => clearInterval(interval);
    }, [disabled, timer]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && otp?.length === 4 && !submitting) {
            handleVerifyOtp();
        }
    };

    const handleResendOtp = async () => {
        if(disabled) return;
        try {
            setDisabled(true);
            setTimer(15);
            const res = await authServices.resendOTP({ mobileNumber: number });
            if (res && res.success) {
                enqueueSnackbar("OTP sent successfully", { variant: "success" });
                logsService.addLog({
                    mobileNumber: number,
                    event: InvestorActivityEventType.RESEND_OTP
                })
            }
            else {
                enqueueSnackbar(res?.message || "Something went wrong!", { variant: "error" });
            }
        } catch (error) {
            enqueueSnackbar(error?.message || "Something went wrong!", { variant: "error" });
        }
    }
    return (
        <>
            <Stack direction={"column"} mt={3} justifyContent={"space-between"}>
                <Typography variant="body2" sx={{ fontSize: 12 }}>OTP Sent To {number}</Typography>
                <Typography onClick={() => setOtpForm(false)} variant="body2" sx={{ fontSize: 12, color: "primary.main", cursor: "pointer" }}>Change Number</Typography>
            </Stack>
            <Stack spacing={1.5} mt={3}>
                <FormField label={"Enter OTP *"} inputProps={{
                    placeholder: "_ _ _ _",
                    type: "text",
                    value: otp,
                    onChange: (e) => {
                        // console.log(RegExp('^[0-9]*$').test(e.target.value));
                        if (RegExp('^[0-9]*$').test(e.target.value) && e.target.value?.length < 5) {
                            setOtp(e.target.value)
                        }
                    },
                    onKeyPress: handleKeyPress,
                }} />
            </Stack>
            <Stack direction={"row"} alignItems={"center"} mt={2} spacing={1}>
                <Typography variant="body2" >Haven't received OTP?</Typography>
                <Typography onClick={handleResendOtp} variant="body2" sx={disabled ? {cursor: "not-allowed"} : { color: "primary.main", cursor: "pointer" }}>{disabled ? `Resend OTP in ${timer}s` : 'Resend OTP'}</Typography>
            </Stack>
            <Button onClick={handleVerifyOtp} disabled={!(otp?.length === 4) || submitting} variant="contained" sx={{ mt: 4 }} fullWidth >{submitting ? "Please wait..." : "Confirm and Next"}</Button>
        </>
    )
}

export default OTPForm